import React from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Link,
  useColorModeValue,
  Spacer,
} from "@chakra-ui/react";
import {
  EnvelopeSimpleIcon,
  FacebookLogoIcon,
  InstagramLogoIcon,
  YoutubeLogoIcon,
  TiktokLogoIcon,
  CaretRightIcon,
} from "@phosphor-icons/react";
import { DEFAULT_WIDTH, PAGE_PADDING } from "../../helpers/constant";
import { useTranslation } from "react-i18next";

const ContactPage = () => {
  const cardBg = useColorModeValue("white", "gray.700");
  const cardHover = useColorModeValue("gray.200", "gray.600");
  const textColor = useColorModeValue("gray.800", "gray.100");

  const { t } = useTranslation();
  const contactItems = [
    {
      title: t("contact.items.email"),
      icon: <EnvelopeSimpleIcon size={24} />,
      href: "mailto:familleenjesuschrist77@gmail.com",
    },
    {
      title: t("contact.items.facebook"),
      icon: <FacebookLogoIcon size={24} />,
      href: "https://web.facebook.com/p/MSA-Famille-en-J%C3%A9sus-Christ-61555542576835",
    },
    {
      title: t("contact.items.instagram"),
      icon: <InstagramLogoIcon size={24} />,
      href: "https://instagram.com/la_famille_en_jesus_christ",
    },
    {
      title: t("contact.items.youtube"),
      icon: <YoutubeLogoIcon size={24} />,
      href: "https://www.youtube.com/@lafamilleenjesuschrist",
    },
    {
      title: t("contact.items.tiktok"),
      icon: <TiktokLogoIcon size={24} />,
      href: "https://www.tiktok.com/@msa_fjc",
    },
  ];

  return (
    <Box w={DEFAULT_WIDTH} px={PAGE_PADDING} mx="auto">
      {/* Description */}
      <Text fontSize="lg" mb={6} color={textColor} lineHeight="taller">
        {t("contact.description")}
      </Text>

      {/* Contact cards */}
      <VStack spacing={{ base: "16px", md: 2 }} align="stretch">
        {contactItems.map((item) => (
          <Link
            key={item.title}
            href={item.href}
            isExternal
            style={{ textDecoration: "none" }}
          >
            <Box
              bg={cardBg}
              _hover={{ bg: cardHover }}
              borderRadius="md"
              p={4}
              h="60px"
              cursor="pointer"
              transition="0.2s"
            >
              <HStack spacing={4} h="full" align="center">
                {item.icon}
                <Text fontWeight="semibold" fontSize="lg" color={textColor}>
                  {item.title}
                </Text>
                <Spacer />
                <CaretRightIcon size={20} />
              </HStack>
            </Box>
          </Link>
        ))}
      </VStack>
    </Box>
  );
};

export default ContactPage;
